module.exports = __webpack_public_path__ + "static/media/statistics.0feda2a1.svg";